<template>
  <div>
    <font-awesome-icon
        style="opacity: 0.85"
        v-if="mRead === false"
        icon="envelope"
    />
    <font-awesome-icon
        style="opacity: 0.6"
        v-else-if="mRead=== true"
        icon="envelope-open"
    />
    <font-awesome-icon
        v-if="notificationIcon !== ''"
        :class="notificationIconColor"
        :icon=notificationIcon
    />
  </div>
</template>
<script>

export default {
  name: "IconClass",

  async created()  {
    await this.loadNotificationData();
  },

  mounted(){
  },

  methods: {
    async loadNotificationData(){
      if(this.model.__pending__){
        return;
      }
      this.mRead = this.model['read'];
      this.notificationIcon = this.model[this.prop].substr(7,this.model[this.prop].length);
      if(this.model['type']  === "WARNING")
        this.notificationIconColor = "text-warning";
      else if(this.model['type']  === "INFO")
        this.notificationIconColor = "text-primary";
      else if(this.model['type']  === "TYPE_EXCLAMATION")
        this.notificationIconColor = "text-danger";
    },
  },

  props: ["rowIndex", "prop", "model", "column"],
  watch: {
    model: function(v){
      this.loadNotificationData();
    }
  },

  data: () => ({
    notificationIcon: "",
    notificationIconColor: "",
    mRead: false,
  })

};
</script>
